<template>
  <div
    class="anz-fs-xxs anz-align-center anz-py-m anz-py-s-sm anz-px-m anz-bg-orange-light anz-b-rounded anz-flex anz-align-items-start anz-mb-l"
  >
    <div class="anz-flex-fill">
      <template v-if="apiError.message === MAX_BLOCKED_USERS">
        <strong class="anz-strong">{{
          $translate('profile.error.maxBlockedUsersTextA')
        }}</strong>
        {{ $translate('profile.error.maxBlockedUsersTextB') }}
      </template>
      <template v-else>
        {{ $translate('profile.error.default') }}
      </template>
    </div>
    <a-button
      class-name="anz-link anz-color-beige anz-ml-m anz-block anz-mtn-xxs-mo anz-mrn-xxs-mo anz-mt-xs-sm"
      @click="$emit('tooltip-close')"
      show-icon
      icon-width="0.7142em"
      icon-height="0.7142em"
      icon-name="cross-solid"
      icon-class="anz-block anz-mtn-xxs"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import ApiError from '@/error/apiError'

export default defineComponent({
  name: 'ProfileApiError',
  components: { AButton },
  data() {
    return {
      active: true,
      MAX_BLOCKED_USERS: 'max_blocked_users',
    }
  },
  props: {
    apiError: {
      type: ApiError,
      required: true,
    },
  },
})
</script>
